import { ChevronDown } from "lucide-react";
import React, { useState } from "react";

import { IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { Divider, Grid, List, useTheme } from "@mui/material";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { SectionHeader } from "@src/components/Navigation/BaseSideNav/SectionHeader";
import { AdminRoutes } from "@src/components/Utils/routes";

interface AdminSectionProps {
  drawerOpen: boolean;
}

export const AdminSection = ({ drawerOpen }: AdminSectionProps) => {
  const isAdmin = useIsAdmin();
  const [expanded, setExpanded] = useState(true);
  const theme = useTheme();
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  if (!isAdmin) return null;
  return (
    <>
      <SectionHeader title="Admin" drawerOpen={drawerOpen} />

      {expanded && (
        <List sx={{ px: drawerOpen ? 2 : 4, paddingTop: drawerOpen ? 0 : 2 }}>
          <IgListItemLink
            hasAccess={true}
            exact={true}
            drawerOpen={drawerOpen}
            Route={AdminRoutes().admin}
          />
          <IgListItemLink
            hasAccess={true}
            exact={true}
            drawerOpen={drawerOpen}
            Route={AdminRoutes().performance}
          />
          <IgListItemLink
            hasAccess={true}
            drawerOpen={drawerOpen}
            Route={AdminRoutes().configCompare}
          />
        </List>
      )}
    </>
  );
};
